module.exports = __webpack_public_path__ + "static/media/cargo-aircraft-lunajets_team.c585df86.jpg";